import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

type Props = {
  open?: boolean;
  onApprove: (transactionDate?: Date) => void;
  onCancel: () => void;
};

const QuickBooksDateModal = ({
  open = false,
  onApprove,
  onCancel
}: Props) => {
  const [transactionDate, setTransactionDate] = useState<Date>();

  const handleApprove = () => {
    onApprove(transactionDate);
  }

  const handleCancel = () => {
    onCancel();
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as='div'
        className='fixed z-10 inset-0 overflow-y-auto'
        // Passing empty function keeps dialog open when user clicks outside it.
        // Close function is handled exclusively by "cancel" button.
        onClose={() => { }}
      >
        <div className='flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Dialog.Overlay className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className='hidden sm:inline-block sm:align-middle sm:h-screen'
            aria-hidden='true'
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            enterTo='opacity-100 translate-y-0 sm:scale-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
          >
            <div className='inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full'>
              {
                <Fragment>
                  <div className='m-5'>
                    <h1 className='my-5'>QuickBooks Transaction Date</h1>
                    <p>Select the date that the export transaction date should be set to.</p>
                    <div className="flex justify-center">
                      <DatePicker
                        name='date-from'
                        selected={transactionDate == null ? new Date() : transactionDate}
                        onChange={(date: Date) => setTransactionDate(date!)}
                        maxDate={moment().add('M', 1).toDate()}
                        dateFormat="MM/dd/yyyy"
                        showFullMonthYearPicker
                      />
                      <div id="date-popup" />
                    </div>
                  </div>
                  <div className='bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-lg'>
                    <button
                      type='button'
                      disabled={false}
                      className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-ptsgreen-normal text-base text-white hover:bg-ptsgreen-dark focus:outline-none sm:ml-3 sm:w-auto sm:text-sm  transition ease-in-out duration-150'
                      onClick={handleApprove}
                    >
                      Approve
                    </button>
                    <button
                      type='button'
                      className='mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base text-gray-700 hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm  transition ease-in-out duration-150'
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </Fragment>
              }
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default QuickBooksDateModal;
